import {FormStepType} from '../../../../../blocks/FormBlock'

const step1: FormStepType = {
	id: 1,
	parent_id: 0,
	channel: 'step',
	label: 'Soort klant',
	sections: [
		{
			id: 1,
			parent_id: 1,
			channel: 'section',
			label: 'Soort klant',
			fields: [
				{
					id: 1,
					parent_id: 1,
					channel: 'select',
					name: 'ik-bestel-voor',
					label: 'Ik bestel voor',
					required: true,
					options: [
						{
							path: 'personal',
							title: 'persoonlijk gebruik'
						},
						{
							path: 'school',
							title: 'een school'
						},
						{
							path: 'organisation',
							title: 'een organisatie of groep'
						}
					]
				}
			]
		}
	],
	submit_text: 'Bevestig'
}

export default step1
